var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"block-area-wrapper"},[_c('transition-group',{staticClass:"block-area",attrs:{"name":"page","tag":"section"}},[_vm._l((_vm.blocks),function(block,i){return _c('BaseBlock',{key:block.id,attrs:{"block":block,"next-block":_vm.blocks[i + 1]}})})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }